/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failedtosendresetemailpleasetryagain7Inputs */

const en_failedtosendresetemailpleasetryagain7 = /** @type {(inputs: Failedtosendresetemailpleasetryagain7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send reset email. Please try again.`)
};

const de_failedtosendresetemailpleasetryagain7 = /** @type {(inputs: Failedtosendresetemailpleasetryagain7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset-E-Mail konnte nicht gesendet werden. Bitte erneut versuchen.`)
};

/**
* | output |
* | --- |
* | "Failed to send reset email. Please try again." |
*
* @param {Failedtosendresetemailpleasetryagain7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const failedtosendresetemailpleasetryagain7 = /** @type {((inputs?: Failedtosendresetemailpleasetryagain7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failedtosendresetemailpleasetryagain7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failedtosendresetemailpleasetryagain7(inputs)
	return de_failedtosendresetemailpleasetryagain7(inputs)
});
export { failedtosendresetemailpleasetryagain7 as "failedToSendResetEmailPleaseTryAgain" }